import React from "react";
import Tile from "../../components/Tile/Tile";
import "./FindGraduateSchools.css";
import { ContentfulTileProps } from "../../utils/contentful-helpers";
import { bookmarkEventBuilder, sendEvent } from "../../utils/event-helpers";
import { toggleResourceBookmark } from "../../features/bookmark/resourceBookmarksSlice";
import { useWithSessionData } from "../../hooks/use-with-session-data";
import { useAppDispatch, useAppSelector } from "../../app/store";

export interface FindGraduateSchoolsTilesProps {
  resourceTiles: ContentfulTileProps[];
}

const FindGraduateSchoolsTiles = ({
  resourceTiles,
}: FindGraduateSchoolsTilesProps) => {
  const { userId, sessionId } = useWithSessionData();
  const dispatch = useAppDispatch();
  const bookmarks = useAppSelector((state) => state.resourceBookmarks.bookmarkedResources);
  const handleBookmarkFindGraduateSchools = (resourceTile: ContentfulTileProps) => {
    const { id, title, description, thumbnail, url } = resourceTile;
    const isBookmarked = bookmarks.some((bookmark) => bookmark.id === id);
    const eventData = bookmarkEventBuilder(!isBookmarked, userId, sessionId, "FindGraduateSchoolsTile", title, {
      bookmarkedResource: {
        title: title,
        description: JSON.stringify(description),
        resource_id: id,
      },
    });
    sendEvent(eventData);

    dispatch(
      toggleResourceBookmark({ id, title, description, thumbnail, url })
    );
  };

  return (
    <div className="internship-wrapper">
      <div className="find-graduate-schools-container">
        {resourceTiles.map((tile) => (
          <Tile
            key={tile.id}
            id={tile.id}
            title={tile.title}
            description={tile.description}
            thumbnail={tile.thumbnail}
            url={tile.url}
            isResearchPage={false}
            onBookmark={() => {
              handleBookmarkFindGraduateSchools(tile);
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default FindGraduateSchoolsTiles;
